export default "__VITE_ASSET__CZT7iKyh__"